export { default } from './FormGeneratorSwitchCDS';
